"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbtack } from "@fortawesome/free-solid-svg-icons";
import { useMyStream } from "@/contexts/wave/MyStreamContext";
import { Tooltip } from "react-tooltip";
import { useAuth } from "@/components/auth/Auth";
import { usePinnedWavesServer, MAX_PINNED_WAVES } from "@/hooks/usePinnedWavesServer";
interface WaveHeaderPinButtonProps {
  readonly waveId: string;
}

// Constants to reduce string duplication
const PIN_ACTIONS = {
  PIN: 'Pin wave',
  UNPIN: 'Unpin wave'
} as const;
const WaveHeaderPinButton: React.FC<WaveHeaderPinButtonProps> = t0 => {
  const $ = _c(48);
  const {
    waveId
  } = t0;
  const {
    waves
  } = useMyStream();
  const {
    pinnedIds,
    isOperationInProgress
  } = usePinnedWavesServer();
  const {
    setToast,
    connectedProfile,
    activeProfileProxy
  } = useAuth();
  const [showMaxLimitTooltip, setShowMaxLimitTooltip] = useState(false);
  let t1;
  if ($[0] !== isOperationInProgress || $[1] !== waveId) {
    t1 = isOperationInProgress(waveId);
    $[0] = isOperationInProgress;
    $[1] = waveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isCurrentlyProcessing = t1;
  let t2;
  if ($[3] !== pinnedIds || $[4] !== waveId) {
    t2 = pinnedIds.includes(waveId);
    $[3] = pinnedIds;
    $[4] = waveId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isPinned = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShowMaxLimitTooltip(false);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const hideTooltip = t3;
  let t4;
  if ($[7] !== setToast) {
    t4 = message => {
      setToast({
        type: "error",
        message
      });
    };
    $[7] = setToast;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const showErrorToast = t4;
  let t5;
  if ($[9] !== isPinned || $[10] !== pinnedIds.length) {
    t5 = () => {
      if (isPinned) {
        return true;
      }
      return pinnedIds.length < MAX_PINNED_WAVES;
    };
    $[9] = isPinned;
    $[10] = pinnedIds.length;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const canPinWave = t5;
  let t6;
  bb0: {
    if (isPinned) {
      t6 = PIN_ACTIONS.UNPIN;
      break bb0;
    }
    if (canPinWave()) {
      t6 = PIN_ACTIONS.PIN;
      break bb0;
    }
    t6 = `Max ${MAX_PINNED_WAVES} pinned waves. Unpin another wave first.`;
  }
  const tooltipContent = t6;
  let t7;
  bb1: {
    if (isPinned) {
      t7 = "tw-text-iron-200 tw-bg-iron-700 desktop-hover:hover:tw-bg-iron-650 desktop-hover:hover:tw-text-iron-100";
      break bb1;
    }
    t7 = "tw-text-iron-500 desktop-hover:hover:tw-text-iron-300 desktop-hover:hover:tw-bg-iron-700 tw-bg-transparent active:tw-bg-iron-700";
  }
  const buttonStyles = t7;
  const ariaLabel = isPinned ? PIN_ACTIONS.UNPIN : PIN_ACTIONS.PIN;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      hideTooltip();
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isPinned) {
    t9 = [isPinned, hideTooltip];
    $[13] = isPinned;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  useEffect(t8, t9);
  let t10;
  if ($[15] !== canPinWave) {
    t10 = () => {
      if (canPinWave()) {
        hideTooltip();
      }
    };
    $[15] = canPinWave;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== canPinWave || $[18] !== pinnedIds) {
    t11 = [pinnedIds, canPinWave, hideTooltip];
    $[17] = canPinWave;
    $[18] = pinnedIds;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[20] !== showMaxLimitTooltip) {
    t12 = () => {
      if (showMaxLimitTooltip) {
        const timer = setTimeout(hideTooltip, 3000);
        return () => clearTimeout(timer);
      }
    };
    t13 = [showMaxLimitTooltip, hideTooltip];
    $[20] = showMaxLimitTooltip;
    $[21] = t12;
    $[22] = t13;
  } else {
    t12 = $[21];
    t13 = $[22];
  }
  useEffect(t12, t13);
  if (!connectedProfile?.handle || activeProfileProxy) {
    return null;
  }
  let t14;
  if ($[23] !== canPinWave || $[24] !== isCurrentlyProcessing || $[25] !== isPinned || $[26] !== showErrorToast || $[27] !== waveId || $[28] !== waves) {
    t14 = async e => {
      e.stopPropagation();
      e.preventDefault();
      if (isCurrentlyProcessing) {
        return;
      }
      ;
      try {
        if (isPinned) {
          waves.removePinnedWave(waveId);
          hideTooltip();
          return;
        }
        if (!canPinWave()) {
          setShowMaxLimitTooltip(true);
          showErrorToast(`Maximum ${MAX_PINNED_WAVES} pinned waves allowed`);
          return;
        }
        waves.addPinnedWave(waveId);
      } catch (t15) {
        const error = t15;
        console.error("Error updating wave pin status:", error);
        const errorMessage = error instanceof Error ? error.message : "Something went wrong";
        const action = isPinned ? "unpin" : "pin";
        showErrorToast(`Failed to ${action} wave: ${errorMessage}`);
      }
    };
    $[23] = canPinWave;
    $[24] = isCurrentlyProcessing;
    $[25] = isPinned;
    $[26] = showErrorToast;
    $[27] = waveId;
    $[28] = waves;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const handleClick = t14;
  const t15 = `tw-border-0 tw-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-lg tw-transition-all tw-duration-200 ${buttonStyles} ${isCurrentlyProcessing ? "tw-opacity-50 tw-cursor-not-allowed" : ""}`;
  const t16 = `wave-header-pin-${waveId}`;
  const t17 = `tw-size-3.5 tw-flex-shrink-0 ${isPinned ? "tw-rotate-[-45deg]" : ""}`;
  let t18;
  if ($[30] !== t17) {
    t18 = <FontAwesomeIcon icon={faThumbtack} className={t17} />;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== ariaLabel || $[33] !== handleClick || $[34] !== isCurrentlyProcessing || $[35] !== t15 || $[36] !== t16 || $[37] !== t18) {
    t19 = <button onClick={handleClick} disabled={isCurrentlyProcessing} className={t15} aria-label={ariaLabel} data-tooltip-id={t16}>{t18}</button>;
    $[32] = ariaLabel;
    $[33] = handleClick;
    $[34] = isCurrentlyProcessing;
    $[35] = t15;
    $[36] = t16;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const t20 = `wave-header-pin-${waveId}`;
  let t21;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== tooltipContent) {
    t22 = <span className="tw-text-xs">{tooltipContent}</span>;
    $[40] = tooltipContent;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t20 || $[43] !== t22) {
    t23 = <Tooltip id={t20} place="top" style={t21}>{t22}</Tooltip>;
    $[42] = t20;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t19 || $[46] !== t23) {
    t24 = <>{t19}{t23}</>;
    $[45] = t19;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  return t24;
};
export default WaveHeaderPinButton;